import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { StartChatSurveyRPC } from "./startChatSurveyRPC";

export class StartChatSurveyRPCClientImpl extends StartChatSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: StartChatSurveyRPC.Request): Promise<LeoRPCResult<StartChatSurveyRPC.Response, StartChatSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/StartChatSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      StartChatSurveyRPC.ResponseDTO,
      StartChatSurveyRPC.Errors.ErrorsDTO,
      StartChatSurveyRPC.Response,
      StartChatSurveyRPC.Errors.Errors
    >(
      response,
      "survey-respondent/StartChatSurvey",
      StartChatSurveyRPC.Response.fromDTO,
      StartChatSurveyRPC.Errors.fromDTO
    );
  }
}
